import axios from 'axios';
import { handleSuccess, handleError } from './axiosHandler';
import { authHeader, authHeaderJson } from '../_helpers/auth-header';

import {config} from '../config';
const base_url = config.apiUrl;

export const dashboardService = {
  getDashbardSummary,
};

function getDashbardSummary() {
  const url = base_url + 'Report/DashbardSummary';
  axios.interceptors.response.use(handleSuccess, handleError);
  return axios.get(url, { headers: authHeader()});
}